import React from 'react';
import { Accordion, Form } from 'react-bootstrap';
import Select from 'react-select';
import { compose, uniq, get as fpGet, map, filter } from 'lodash/fp';
import useQuery from 'reusable/customHooks/useQuery';

import { StyledFilters } from './style';
import { useFetchMetadataQuery } from 'services/api/creativePreview';

const mapOption = value => ({ label: value, value });
const getUniqueValues = key => {
  return compose([filter(el => el), uniq, map(fpGet(key))]);
};

function Filters({ data }) {
  const [query, setQuery] = useQuery();
  const { data: filters = [] } = useFetchMetadataQuery('filters');

  const getValue = (label, isMulti = false) => {
    const res = query.get(label);
    if (!res) return isMulti ? [] : undefined;
    return isMulti ? res.split(',').map(mapOption) : mapOption(res);
  };

  const setValue = (label, res, isMulti = false) => {
    if (!res || !res.length) setQuery(label, '');
    if (isMulti) setQuery(label, res.map(el => el.value).join(','));
    else setQuery(label, res.value);
  };

  return (
    <StyledFilters>
      <Accordion.Header>Filters</Accordion.Header>
      <Accordion.Body>
        {filters.map(filter => (
          <Form.Group className="form-group" key={filter.key}>
            <Form.Label>{filter.label}</Form.Label>
            <Select
              value={getValue(filter.key, filter.isMulti)}
              onChange={res => setValue(filter.key, res, filter.isMulti)}
              options={(filter.list || getUniqueValues(filter.path)(data)).map(
                mapOption,
              )}
              isClearable
              isMulti={filter.isMulti}
              className="form-input"
            />
          </Form.Group>
        ))}
      </Accordion.Body>
    </StyledFilters>
  );
}

export default Filters;
